import React from "react"

export const icons = {
  "Astrology": null,
  "Beauty": "category-beauty",
  "Body Positivity": "category-skin-care",
  "Change-Makers": "category-change-makers",
  "Climate Change": "category-climate-change",
  "Feng Shui": "category-meditation",
  "Financial Wellness": "category-star",
  "Food Trends": "category-food-trends",
  "Friendships": "category-friendships",
  "Functional Food": "category-functional-food",
  "Green Cleaning": "category-home-tours",
  "Healthy Weight": "category-healthy-weight",
  "Home Tours": "category-home-tours",
  "Home": "category-home",
  "Integrative Health": "category-integrative-health",
  "Love": "category-love",
  "Makeup": "category-makeup",
  "Meditation": "category-meditation",
  "Mental Health": "category-mental-health",
  "Motivation": "category-motivation",
  "Nature": "category-nature",
  "News": "category-news",
  "Off-The-Grid": "category-off-the-grid",
  "Outdoors": "category-outdoors",
  "Parenting": "category-parenting",
  "Personal Growth": "category-personal-growth",
  "Pregnancy": "category-parenting",
  "Prosperity": "category-prosperity",
  "Raising Kids": "category-parenting",
  "Recipes": "category-recipes",
  "Recovery": "category-recovery",
  "Routines": "category-routines",
  "Sex": "category-sex",
  "Skin Care": "category-skin-care",
  "Social Good": "category-social-good",
  "Spirituality": "category-spirituality",
  "Star": "category-star",
  "Style": "category-style",
  "Travel": "category-travel",
  "Trying": "category-parenting",
  "Wellness Trends": "category-wellness-trends",
  "Women's Health": "category-womens-health",
  "Yoga": "category-star",
  "Eye-open": "eye-open",
}

const Icon = ({ name, ...props }) => {
  const Component = name in icons ? icons[name] : null
  return Component ? <Component {...props} /> : null
}

export default Icon
